var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wp-4 mx-auto upload-area" },
    [
      _c(
        "el-form",
        [
          _c(
            "el-form-item",
            [
              _c(
                "el-upload",
                {
                  ref: "uploader",
                  staticClass: "wp-10",
                  class: {
                    "undrag shadow":
                      _vm.isProcessing ||
                      _vm.isUploading ||
                      _vm.technicalIssue ||
                      _vm.errorFileList.length
                  },
                  attrs: {
                    drag: "",
                    multiple: "",
                    accept: _vm.mimeTypes,
                    action: _vm.actionUploadUrl,
                    "file-list": _vm.fileList,
                    "on-error": _vm.handleError,
                    "on-success": _vm.handleSuccess,
                    "on-exceed": _vm.handleExceed,
                    "before-upload": _vm.handleBeforeUpload,
                    "show-file-list": false,
                    limit: 50,
                    disabled: _vm.technicalIssue
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "flex-column hp-10 jc-center ai-center",
                      on: { click: _vm.handleClickUploader }
                    },
                    [
                      _vm.isProcessing || _vm.isUploading
                        ? [
                            _c("div", {
                              staticClass: "loader loader-arrow--spin"
                            }),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$l10n.n__(
                                      "%d document en cours de traitement",
                                      "%d documents en cours de traitement",
                                      _vm.totalFiles,
                                      _vm.totalFiles
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c("CompassButton", {
                              staticClass: "mt-4",
                              attrs: {
                                label: _vm.$t.__(
                                  "ocr.UploadForm.import_other_documents"
                                ),
                                type: "secondary"
                              }
                            })
                          ]
                        : _vm.technicalIssue
                        ? [
                            _c("i", {
                              staticClass:
                                "icon-email-statut-fail fs-icon-dragndrop red"
                            }),
                            _vm._v(" "),
                            _c("p", { staticClass: "semibold" }, [
                              _vm._v(_vm._s(_vm.$l10n.__("Erreur technique")))
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "wp-6" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$l10n.__(
                                      "Notre partenaire rencontre actuellement un problème technique, le service est indisponible pour le moment."
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ])
                          ]
                        : _vm.limitExceed
                        ? [
                            _c("i", {
                              staticClass:
                                "icon-email-statut-fail fs-icon-dragndrop red"
                            }),
                            _vm._v(" "),
                            _c("p", { staticClass: "semibold" }, [
                              _vm._v(_vm._s(_vm.$l10n.__("Limite atteinte")))
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "wp-6 gray-60" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$l10n.__(
                                      "Vous ne pouvez envoyez que 50 fichiers à la fois."
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ])
                          ]
                        : _vm.quotaExceed
                        ? [
                            _c("i", {
                              staticClass:
                                "icon-notification-fillout fs-icon-dragndrop red"
                            }),
                            _vm._v(" "),
                            _c("p", { staticClass: "semibold" }, [
                              _vm._v(_vm._s(_vm.$l10n.__("Erreur de quota")))
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "wp-6 gray-60" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$l10n.__(
                                      "Vous avez atteint la totalité de votre quota d'import."
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ])
                          ]
                        : _vm.errorFileList.length
                        ? [
                            _c("i", {
                              staticClass:
                                "icon-notification-fillout fs-icon-dragndrop red"
                            }),
                            _vm._v(" "),
                            _vm.errorCode === 400
                              ? _c("p", { staticClass: "semibold fs-3" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$l10n.n__(
                                          "Fichier invalide. Vérifiez le poids et le format",
                                          "Fichiers invalides. Vérifiez le poids et le format",
                                          _vm.errorFileList.length,
                                          _vm.errorFileList.length
                                        )
                                      ) +
                                      "\n                        "
                                  )
                                ])
                              : _c("p", { staticClass: "semibold fs-3" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$l10n.n__(
                                          "%d document en erreur",
                                          "%d documents en erreur",
                                          _vm.errorFileList.length,
                                          _vm.errorFileList.length
                                        )
                                      ) +
                                      "\n                        "
                                  )
                                ]),
                            _vm._v(" "),
                            _c(
                              "ul",
                              { staticClass: "m-0" },
                              _vm._l(_vm.errorsPreviewList, function(file) {
                                return _c(
                                  "li",
                                  { key: file.id, staticClass: "gray-60" },
                                  [
                                    file.file_name
                                      ? [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(file.file_name) +
                                              "\n                                "
                                          )
                                        ]
                                      : [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(file.name) +
                                              "\n                                "
                                          )
                                        ]
                                  ],
                                  2
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _vm.errorFileList.length > 5
                              ? _c("span", { staticClass: "grey mt-1" }, [
                                  _vm._v(
                                    "+\n                            " +
                                      _vm._s(
                                        _vm.$l10n.n__(
                                          "%d autre document",
                                          "%d autres documents",
                                          _vm.errorFileList.length - 5,
                                          _vm.errorFileList.length - 5
                                        )
                                      )
                                  )
                                ])
                              : _vm._e()
                          ]
                        : [
                            _c(
                              "p",
                              { staticClass: "black el-upload__text m-0 mb-2" },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.$l10n.__(
                                        "Glisser - déposer des documents depuis votre ordinateur"
                                      )
                                    ) +
                                    "\n                        "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("p", { staticClass: "grey m-0 mb-2" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$l10n.__(
                                      "JPEG, PNG, WEBP image, PDF de maximum 5 pages et inférieur à 5MB."
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "grey m-0" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$l10n.__(
                                      "(Import maximum de 50 fichiers à la fois)"
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _vm.isTrial
                              ? _c("p", { staticClass: "red semibold mb-0" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$l10n.__(
                                          "En période d’essai, vous êtes limité à un import de 20 documents"
                                        )
                                      ) +
                                      "\n                        "
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("CompassButton", {
                              staticClass: "mt-3",
                              attrs: {
                                label: _vm.$t.__(
                                  "ocr.UploadForm.import_document"
                                ),
                                type: "secondary"
                              }
                            })
                          ],
                      _vm._v(" "),
                      (_vm.limitExceed ||
                        _vm.quotaExceed ||
                        _vm.errorFileList.length) &&
                      !_vm.isUploading &&
                      !_vm.isProcessing
                        ? [
                            _c("CompassButton", {
                              staticClass: "mt-3",
                              attrs: {
                                label: _vm.$t.__(
                                  "ocr.UploadForm.back_to_document_import"
                                ),
                                type: "secondary"
                              },
                              on: { click: _vm.backToUpload }
                            })
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }